import React from 'react';
import { RefreshedMobileSiteNavMenuQuery } from '../../../../generated/types';
import { RefreshedMobileNavMainCategoryItem } from '../RefreshedMobileNavMainCategoryItem';
import { RefreshedMobileSiteNavExpandable } from '../RefreshedMobileSiteNavExpandable';
import './RefreshedMobileSiteNavMenuVerticalCategoryFashion.scss';

type MainCategory = NonNullable<
  RefreshedMobileSiteNavMenuQuery['displayPage']
>['data']['tabs'][number]['mainCategories'][number];

type MainCategoryItem = MainCategory['mainCategoryItems'][number];

type SubItem = MainCategoryItem['subItems'][number];

type ListLink = NonNullable<SubItem['listLinks']>[number];

interface Props {
  data: MainCategory | MainCategoryItem | SubItem | ListLink;
  onClose: () => void;
  expandedSection: string | undefined;
  setExpandedSection: (label: string | undefined) => void;
  label: string;
}

export const RefreshedMobileSiteNavMenuVerticalCategoryFashion: React.FC<Props> = ({
  data,
  onClose,
  expandedSection,
  setExpandedSection,
  label
}) => {
  if (data.__typename === 'MobileNavMainCategory') {
    return (
      <RefreshedMobileSiteNavExpandable
        title={data.label}
        url={data.url || undefined}
        styleProps={data.styleProps}
        expandedSection={expandedSection}
        setExpandedSection={setExpandedSection}
      >
        {data.mainCategoryItems.map((option, index) => (
          <RefreshedMobileSiteNavMenuVerticalCategoryFashion
            key={index + data.label}
            data={option}
            onClose={onClose}
            expandedSection={expandedSection}
            setExpandedSection={setExpandedSection}
            label={label}
          />
        ))}
      </RefreshedMobileSiteNavExpandable>
    );
  }
  if (data.__typename === 'MobileNavMainCategoryItem') {
    return (
      <>
        {data.subItems.length > 0 &&
          data.subItems[0].centerTitle === false &&
          data.subItems[0].label !== '' && (
            <span className="RefreshedMobileSiteNavMenuVerticalCategoryFashion_curations">
              {data.subItems[0].label}
            </span>
          )}
        {data.subItems.map((option, index) => (
          <RefreshedMobileNavMainCategoryItem key={index} data={option} onClose={onClose} />
        ))}
      </>
    );
  }

  return null;
};
